import { HelpCircle } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * インラインヘルプツールチップ
 * ラベルの横に小さな ? アイコンを表示し、ホバーで説明を出す
 * Portal を使うため overflow-hidden の親でも正しく表示される
 */
export default function HelpTip({ text }: { text: string }) {
  const [show, setShow] = useState(false);
  const iconRef = useRef<HTMLSpanElement>(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (show && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setPos({
        top: rect.top - 8,
        left: rect.left + rect.width / 2,
      });
    }
  }, [show]);

  return (
    <span
      className="inline-flex items-center ml-1"
      ref={iconRef}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <HelpCircle size={13} className="text-slate-300 hover:text-blue-400 cursor-help" />
      {show &&
        createPortal(
          <span
            className="fixed px-2.5 py-1.5 bg-slate-800 text-white text-xs rounded shadow-lg whitespace-nowrap z-[9999] max-w-xs -translate-x-1/2 -translate-y-full pointer-events-none"
            style={{ top: pos.top, left: pos.left }}
          >
            {text}
          </span>,
          document.body,
        )}
    </span>
  );
}
